import { NzSafeAny } from 'ng-zorro-antd/core/types';

/** Used as references for various `Number` constants. */
const NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
const reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
const reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
const reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
const reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
const freeParseInt = parseInt;

export function isNumber(value: number | string): boolean {
  return typeof value === 'number';
}

export function toNumber(sourceValue: number | string): number {
  if (typeof sourceValue === 'number') {
    return sourceValue;
  }
  const value = sourceValue.replace(reTrim, '');
  const isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

// tslint:disable-next-line: no-any
export function valToNumber(val: string | number, defaultVal: number = 0): number {
  if (isNumber(toNumber(val)) && !isNaN(toNumber(val))) {
    return toNumber(val);
  } else {
    return defaultVal;
  }
}

/**
 * 填充原始 rotationList
 * @param source
 * @param total
 * @returns
 */
export function padRotationList(source: number[], total: number): number[] {
  if (source.length < total) {
    return new Array(total).fill(0).map((e, idx) => {
      return source[idx] ?? e;
    });
  }
  return source;
}

export function launchFullscreen(element: NzSafeAny): void {
  if (!element) {
    return;
  }
  if (element.requestFullscreen) {
    element.requestFullscreen();
  } else if (element.mozRequestFullScreen) {
    element.mozRequestFullScreen();
  } else if (element.webkitRequestFullscreen) {
    element.webkitRequestFullscreen();
  } else if (element.msRequestFullscreen) {
    element.msRequestFullscreen();
  }
}

export function exitFullscreen(): void {
  const doc = document as NzSafeAny;
  if (!doc.fullscreenElement) {
    return;
  }
  if (doc.exitFullscreen) {
    doc.exitFullscreen();
  } else if (doc.msExitFullscreen) {
    doc.msExitFullscreen();
  } else if (doc.mozCancelFullScreen) {
    doc.mozCancelFullScreen();
  } else if (doc.webkitExitFullscreen) {
    doc.webkitExitFullscreen();
  }
}
